import { render, staticRenderFns } from "./PSkillTagBanner.vue?vue&type=template&id=482a6352&scoped=true&"
import script from "./PSkillTagBanner.vue?vue&type=script&lang=ts&"
export * from "./PSkillTagBanner.vue?vue&type=script&lang=ts&"
import style0 from "./PSkillTagBanner.vue?vue&type=style&index=0&id=482a6352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482a6352",
  null
  
)

export default component.exports